import type enCctv from "../en/en_cctv";

// Static UI copy only. Camera names, incident descriptions and recorded data are not translated.
export const plCctv = {
  errors: {
    cameraName: "Nazwa kamery jest wymagana.",
    cameraCode: "Kod kamery może zawierać litery, cyfry, kropki, podkreślenia i łączniki.",
    cameraConflict: "Kamera o tym kodzie już istnieje w tym hotelu.",
    cameraMissing: "Nie znaleziono kamery dla tego hotelu.",
    cameraUnavailable: "Kamera jest niedostępna dla tego hotelu.",
    guestMask: "Dodaj maskę prywatności w strefie gości lub wyraźnie potwierdź podgląd bez maski.",
    masks: "Maski prywatności muszą być listą prawidłowych obszarów obrazu.",
    maskRange: "Maska {{number}}: {{field}} musi być wartością procentową od 0 do 100.",
    retentionRange: "{{field}} musi być całkowitą liczbą dni od 1 do 3650.",
    retentionOrder: "Okres przechowywania incydentów nie może być krótszy niż okres standardowy.",
    incidentTitle: "Tytuł incydentu jest wymagany.",
    incidentMissing: "Nie znaleziono incydentu dla tego hotelu.",
    incidentEvents: "Co najmniej jedno zdarzenie nie należy do tego hotelu.",
    eventAcknowledged: "Nie znaleziono zdarzenia lub zostało już potwierdzone.",
    recordingMissing: "Nie znaleziono nagrania dla tego hotelu.",
    timelineRange: "Koniec okresu musi przypadać po jego początku.",
    request: "Żądanie CCTV nie powiodło się ({{status}}).",
    unknown: "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
    network: "Nie udało się połączyć z serwerem. Sprawdź połączenie i spróbuj ponownie.",
  },
  errorField: {
    retentionDays: "Okres przechowywania",
    standardRetentionDays: "Standardowy okres przechowywania",
    incidentRetentionDays: "Okres przechowywania incydentów",
    x: "Pozycja pozioma",
    y: "Pozycja pionowa",
    width: "Szerokość",
    height: "Wysokość",
  },
  auditAction: {
    "camera.created": "Utworzono kamerę",
    "camera.updated": "Zaktualizowano kamerę",
    "event.recorded": "Zarejestrowano zdarzenie",
    "event.acknowledged": "Potwierdzono zdarzenie",
    "incident.created": "Utworzono incydent",
    "incident.updated": "Zaktualizowano incydent",
    "recording.playback": "Odtworzono nagranie",
    "recording.export": "Wyeksportowano nagranie",
    "retention_policy.updated": "Zaktualizowano zasady przechowywania",
  },
  auditEntity: {
    camera: "Kamera",
    event: "Zdarzenie",
    incident: "Incydent",
    recording: "Nagranie",
    retention_policy: "Zasady przechowywania",
  },
  zone: {
    guest: "Strefa gości",
    staff: "Personel",
    back_of_house: "Zaplecze",
    outdoor: "Teren zewnętrzny",
  },
  status: {
    online: "Na żywo",
    offline: "Brak połączenia",
    alert: "Alarm",
    disabled: "Wyłączona",
  },
  recordingMode: {
    continuous: "Nagrywanie ciągłe",
    event: "Nagrywanie po wykryciu zdarzenia",
    disabled: "Bez nagrywania",
  },
  source: {
    motion: "Ruch",
    ai: "Wykrywanie przez AI",
    access: "Kontrola dostępu",
    system: "System",
  },
  incidentStatus: {
    open: "Otwarty",
    investigating: "W trakcie wyjaśniania",
    closed: "Zamknięty",
  },
  severity: {
    low: "Niska",
    medium: "Średnia",
    high: "Wysoka",
    critical: "Krytyczna",
    info: "Informacja",
    warning: "Ostrzeżenie",
  },
  incidentType: {
    security: "Bezpieczeństwo",
    theft: "Kradzież",
    damage: "Uszkodzenie mienia",
    noise: "Zakłócanie ciszy",
    maintenance: "Usterka techniczna",
    operations: "Sprawy operacyjne",
    other: "Inne",
  },
  common: {
    loadFailed: "Nie udało się wczytać danych",
    retry: "Spróbuj ponownie",
    loading: "Wczytywanie …",
    missingPermission: "Brak uprawnienia: {{key}}",
    hotelListUnavailable: "Nie udało się wczytać listy hoteli.",
    refresh: "Odśwież",
    acknowledge: "Potwierdź odczytanie",
    days: "{{count}} dni",
    days_one: "{{count}} dzień",
    days_few: "{{count}} dni",
    days_many: "{{count}} dni",
    days_other: "{{count}} dnia",
    never: "nigdy",
    unknown: "nieznany",
    close: "Zamknij",
    cancel: "Anuluj",
    save: "Zapisz",
    discard: "Odrzuć zmiany",
    none: "—",
  },
  nav: {
    live: "Podgląd na żywo",
    cameras: "Kamery",
    recordings: "Nagrania",
    incidents: "Incydenty",
    events: "Zdarzenia",
    access: "Kontrola dostępu",
    privacy: "Prywatność",
    health: "Stan systemu",
  },
  layout: {
    title: "Centrum monitoringu",
    camerasOnline: "Kamery z połączeniem: {{online}} z {{total}}",
    openIncidents: "Otwarte incydenty: {{count}}",
    createIncident: "Utwórz incydent",
    hotelListError: "Nie udało się wczytać listy hoteli",
    resolvingHotel: "Ustalanie hotelu …",
    property: "Hotel",
  },
  tile: {
    recording: "NAGR.",
    noSignal: "Brak sygnału",
    lastImage: "Ostatni obraz: {{time}}",
    masked: "Zamaskowano: {{label}}",
    maskedCount: "Zamaskowane strefy: {{count}}",
    alerts: "Alerty: {{count}}",
    recheck: "Sprawdź ponownie",
    open: "Otwórz pełny podgląd kamery {{name}}",
  },
  fullView: {
    subtitle: "{{code}} · {{location}}",
    noStream: "Obraz na żywo dostarcza adapter {{adapter}}. W tym podglądzie przeglądarkowym nie podłączono strumienia wideo.",
    lastSeen: "Ostatni sygnał",
    zone: "Strefa",
    recording: "Nagrywanie",
    retention: "Okres przechowywania",
    masks: "Maski prywatności",
    status: "Status",
    openAlerts: "Otwarte alerty",
  },
  live: {
    subtitle: "{{property}} · Bieżące zdarzenia i sprawy wymagające uwagi.",
    noKpis: "Brak dostępnych wskaźników",
    camerasOnline: "Kamery z połączeniem",
    allReachable: "Wszystkie dostępne",
    withoutSignal: "Bez sygnału: {{count}}",
    openIncidents: "Otwarte incydenty",
    criticalCount: "Krytyczne: {{count}}",
    noneCritical: "Brak krytycznych",
    aiEventsToday: "Dzisiejsze zdarzenia AI",
    ofEventsTotal: "Łączna liczba zdarzeń: {{count}}",
    retention: "Okres przechowywania",
    retentionDefault: "Jeszcze nie ustawiono · wartość domyślna",
    incidentRetention: "Przechowywanie incydentów — liczba dni: {{count}}",
    noCameras: "Nie skonfigurowano jeszcze kamer",
    noCamerasHint: "Dodaj pierwszą kamerę dla tego hotelu w zakładce „Kamery”.",
    attention: "Wymaga uwagi",
    attentionSummary: "Otwarte incydenty: {{incidents}} · niepotwierdzone alerty: {{alerts}}",
    nothingOpen: "Brak otwartych spraw",
    nothingOpenHint: "Brak otwartych incydentów. Wszystkie alerty zostały potwierdzone.",
    incidentOpened: "{{reference}} · otwarto {{time}}",
  },
  cameras: {
    subtitle: "{{property}} · Lokalizacja, strefa, tryb nagrywania i okres przechowywania.",
    add: "Dodaj kamerę",
    emptyHint: "Dodaj pierwszą kamerę, aby pojawiła się w podglądzie na żywo.",
    colCamera: "Kamera",
    colLocation: "Lokalizacja",
    colZone: "Strefa",
    colStatus: "Status",
    colRecording: "Nagrywanie",
    colRetention: "Okres przechowywania",
    colPrivacy: "Prywatność",
    colActions: "Działania",
    zonesMasked: "Zamaskowane strefy: {{count}}",
    guestAreaUnmasked: "Strefa gości bez maski",
    edit: "Edytuj",
    activate: "Włącz",
    deactivate: "Wyłącz",
  },
  recordings: {
    subtitle: "{{property}} · Odtwarzanie w trybie dowodowym — każdy dostęp jest rejestrowany.",
    camera: "Kamera",
    density: "Liczba zdarzeń w czasie",
    densityHint: "Ostatnie 24 godziny — bez konieczności przeglądania godzin bez zdarzeń.",
    noEvents: "Brak zdarzeń w tym okresie",
    noEventsHint: "W ciągu ostatnich 24 godzin nie zarejestrowano zdarzeń dla tej kamery.",
    bucketTitle: "{{time}} · liczba zdarzeń: {{count}}",
    bucketCritical: ", w tym krytyczne: {{count}}",
    clips: "Nagrania",
    clipCount: "Liczba nagrań: {{count}}",
    none: "Brak nagrań",
    noneHint: "Brak zapisanych nagrań dla tej kamery.",
    colStart: "Początek",
    colDuration: "Czas trwania",
    colIncident: "Incydent",
    linked: "powiązany",
    evidence: "Materiał dowodowy",
    normal: "Zwykłe",
    play: "Odtwórz",
    export: "Eksportuj",
  },
  incidents: {
    subtitle: "{{property}} · Zdarzenia z kamer, kontroli dostępu i systemu na jednej osi czasu.",
    list: "Lista incydentów",
    entries: "Liczba wpisów: {{count}}",
    none: "Brak incydentów",
    noneHint: "Dla tego hotelu nie utworzono jeszcze żadnego incydentu.",
    eventCount: "Liczba zdarzeń: {{count}}",
    sequence: "Przebieg zdarzeń",
    pickOne: "Wybierz incydent po lewej stronie.",
    noneSelected: "Nie wybrano incydentu",
    noneSelectedHint: "Oś czasu pojawi się po wybraniu incydentu z listy po lewej stronie.",
    laneCamera: "Kamera",
    laneAi: "AI",
    laneAccess: "Kontrola dostępu",
    laneSystem: "System",
    noTimelineEvents: "Brak zdarzeń w wybranym przedziale czasu",
    noTimelineEventsHint: "Nie zarejestrowano jeszcze zdarzeń z kamer ani kontroli dostępu dla tego incydentu.",
    timelineFoot: "Powiązane zdarzenia są wyróżnione. Pozostałe wystąpiły jedynie w tym samym przedziale czasu.",
  },
  events: {
    subtitle: "{{property}} · Ruch, wykrywanie przez AI i komunikaty systemowe.",
    open: "Otwarte",
    all: "Wszystkie",
    none: "Brak zdarzeń",
    noneHint: "Dla tego hotelu nie zarejestrowano jeszcze żadnych zdarzeń.",
    nothingOpenHint: "Wszystkie alerty zostały potwierdzone.",
    colTime: "Czas",
    colSource: "Źródło",
    colEvent: "Zdarzenie",
    colConfidence: "Pewność wykrycia",
    colAction: "Działanie",
    measured: "pomiar",
    acknowledged: "Potwierdzone",
  },
  access: {
    subtitle: "{{property}} · Zdarzenia przesyłane przez Keycoder przez interfejs przyjmowania danych.",
    none: "Brak zdarzeń kontroli dostępu",
    noneHint: "Gdy Keycoder wyśle zdarzenia do POST /api/hotels/:id/cctv/events, pojawią się tutaj i na osi czasu incydentu.",
  },
  privacy: {
    subtitle: "{{property}} · Okresy przechowywania, maskowanie i rejestr dostępu.",
    noPolicyTitle: "Nie ustawiono jeszcze okresu przechowywania",
    noPolicyText: "Obowiązuje domyślny okres — liczba dni: {{count}}. Dopóki ustawienia nie zostaną zapisane, decyzja nie jest udokumentowana — to za mało na potrzeby porozumienia pracowniczego lub wniosku o dostęp do danych na podstawie art. 15 RODO.",
    retention: "Okres przechowywania",
    retentionHint: "Dotyczy wszystkich kamer bez własnego okresu przechowywania.",
    noPolicy: "Nie udało się wczytać zasad",
    standardDays: "Standardowy okres (dni)",
    incidentDays: "Okres dla incydentów (dni)",
    saveFailed: "Nie udało się zapisać zmian.",
    lastChanged: "Ostatnia zmiana: {{value}}",
    masking: "Maskowanie",
    maskingHint: "Kamery w strefach gości bez maski prywatności.",
    openCount: "Do uzupełnienia: {{count}}",
    noOpenItems: "Brak spraw do uzupełnienia",
    noOpenItemsHint: "Każda kamera w strefie gości ma co najmniej jedną zamaskowaną strefę.",
    withoutMask: "Bez maski",
    auditLog: "Rejestr dostępu",
    auditLogHint: "Odtwarzanie, eksport i zmiany — rejestr zabezpieczony przed modyfikacją.",
    noAudit: "Brak wpisów",
    noAuditHint: "Gdy ktoś obejrzy lub wyeksportuje nagranie, informacja pojawi się tutaj.",
    colAction: "Działanie",
    colObject: "Obiekt",
    colPerson: "Osoba",
  },
  health: {
    subtitle: "{{property}} · Adaptery, dostępność kamer i zapisane nagrania.",
    recheck: "Sprawdź ponownie",
    none: "Brak danych o stanie systemu",
    adapters: "Adaptery",
    adaptersHint: "Niezależnie od dostawcy, osobno dla każdego połączenia.",
    noAdapters: "Nie podłączono kamer.",
    onlineOf: "{{online}} / {{total}} z połączeniem",
    complete: "Wszystkie dostępne",
    partial: "Częściowo dostępne",
    storage: "Zapisane nagrania",
    storageHint: "Zarejestrowany materiał.",
    clips: "Nagrania",
    totalDuration: "Łączny czas trwania",
    evidenceLocked: "Zabezpieczone jako materiał dowodowy",
    staleTitle: "Kamery bez aktualnego sygnału",
    staleHint: "Brak sygnału przez ponad 15 minut.",
    allReporting: "Wszystkie kamery przesyłają sygnał",
    allReportingHint: "Żadne urządzenie nie pozostaje bez sygnału dłużej niż 15 minut.",
    neverSeen: "brak zarejestrowanego sygnału",
  },
  dialogs: {
    busySaving: "Zapisywanie …",
    busyCreating: "Tworzenie …",
    editCamera: "Edytuj kamerę · {{code}}",
    addCamera: "Dodaj kamerę",
    editCameraHint: "Zmiany są zapisywane w rejestrze dostępu.",
    addCameraHint: "Kod i nazwa są wymagane.",
    saveChanges: "Zapisz zmiany",
    createCamera: "Utwórz kamerę",
    name: "Nazwa",
    namePlaceholder: "Korytarz na 3. piętrze",
    code: "Kod",
    location: "Lokalizacja",
    locationPlaceholder: "3. piętro, skrzydło wschodnie",
    zone: "Strefa",
    recordingMode: "Tryb nagrywania",
    retentionDays: "Okres przechowywania (dni)",
    maskedZones: "Zamaskowane strefy · wartości w procentach obrazu",
    noMaskedZone: "Nie zamaskowano żadnej strefy.",
    maskLabel: "Nazwa strefy",
    maskLabelPlaceholder: "Leżaki",
    remove: "Usuń",
    addZone: "Dodaj strefę",
    maskZoneLabel: "Strefa {{count}}",
    unmaskedAck: "Ta kamera obejmuje strefę gości bez zamaskowanego obszaru. Jest to świadoma decyzja, która zostanie zapisana w rejestrze.",
    saveFailed: "Nie udało się zapisać zmian.",
    createFailed: "Nie udało się utworzyć incydentu.",
    createIncident: "Utwórz incydent",
    createIncidentHint: "Numer incydentu jest nadawany automatycznie.",
    title: "Tytuł",
    titlePlaceholder: "Powtarzające się próby wejścia do pokoju 314",
    type: "Typ",
    severity: "Waga",
    status: "Status",
    camera: "Kamera",
    noCamera: "Bez kamery",
    accessLog: "Numer wpisu w rejestrze dostępu",
    assignedTo: "Przypisano do",
    assignedToPlaceholder: "Zmiana nocna",
    description: "Opis",
    descriptionPlaceholder: "Co się wydarzyło i jakie działania już podjęto?",
  },
} satisfies typeof enCctv;

export default plCctv;
